var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLifePreserverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.48 105.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3aae50;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#c5cfd4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.68,1.66C24.47,1.66,1.6,24.53,1.6,52.74s22.87,51.08,51.08,51.08,51.08-22.87,51.08-51.08S80.89,1.66,52.68,1.66ZM52.68,80.03c-15.07,0-27.29-12.22-27.29-27.29s12.22-27.29,27.29-27.29,27.29,12.22,27.29,27.29-12.22,27.29-27.29,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.96,66.99c-7.96-2.12-15.72-4.23-22.12-5.94.7-2.22,1.14-5.22,1.15-8.61,0-3.16-.55-6.06-1.15-8.01,6.25-1.68,14.05-3.79,22.05-5.94,2.18,9.6,2.05,18.85.07,28.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.52,66.99c7.96-2.12,15.72-4.23,22.12-5.94-.7-2.22-1.14-5.22-1.15-8.61,0-3.16.55-6.06,1.15-8.01-6.25-1.68-14.05-3.79-22.05-5.94-2.18,9.6-2.05,18.85-.07,28.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.49,103.96c2.12-7.96,4.23-15.72,5.94-22.12,2.22.7,5.22,1.14,8.61,1.15,3.16,0,6.06-.55,8.01-1.15,1.68,6.25,3.79,14.05,5.94,22.05-9.6,2.18-18.85,2.05-28.5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.49,1.52c2.12,7.96,4.23,15.72,5.94,22.12,2.22-.7,5.22-1.14,8.61-1.15,3.16,0,6.06.55,8.01,1.15,1.68-6.25,3.79-14.05,5.94-22.05-9.6-2.18-18.85-2.05-28.5-.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifePreserverIcon);
export default __webpack_public_path__ + "static/media/life-preserver-icon.4f11998adf934b08f27f0ca0814175d5.svg";
export { ForwardRef as ReactComponent };